import postAPI from './postAPI.js'

export default async function postUpdateTaskFlow(taskFlowData) {
    const data = await postAPI('admin/taskflows/update', taskFlowData);
    return data;
}
